import getProjectConditions from 'portal-modules/common/utils/get-project-conditions'
const { isRP } = getProjectConditions()

export default ({ leases, properties, user }) =>
  isRP
    ? (!!user.customerId &&
        !!leases[user.leaseId] &&
        !!properties[user.propertyId]) ||
      (!!user.customerId && !!properties[user.propertyId])
    : (!!user.token &&
        !!leases[user.leaseId] &&
        !!properties[user.propertyId]) ||
      (!!user.token && !!properties[user.propertyId])
